"use strict";

var _Column, _Column2;
import { SectionLoading } from '@autoguru/components';
import AppSideHandle from '@autoguru/components/components/AppAsideHandle/AppSideHandle';
import { CDN } from '@autoguru/global-configs';
import { HeaderLayout } from '@autoguru/header-layout';
import { Anchor, Column, Columns } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { SupplierRequiredBoundary } from '@autoguru/supplier-provider';
import { SupportHeader } from '@autoguru/support-header';
import { AsyncBoundary } from '@autoguru/suspense';
import { GlobalNotification } from '~/src/features/app-header/components/GlobalNotification';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AppHeaderMobile = () => /*#__PURE__*/_jsx(HeaderLayout, {
  safePaddings: true,
  children: /*#__PURE__*/_jsxs(Columns, {
    space: "5",
    children: [_Column || (_Column = /*#__PURE__*/_jsxs(Column, {
      noShrink: true,
      alignSelf: "centre",
      display: "flex",
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(SupportHeader, {}), /*#__PURE__*/_jsx(SupplierRequiredBoundary, {
        noSelect: true,
        children: /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: SectionLoading,
          children: /*#__PURE__*/_jsx(GlobalNotification, {})
        })
      })]
    })), /*#__PURE__*/_jsx(Column, {
      grow: true,
      alignSelf: "centre",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Anchor, {
        href: "/",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(Picture, {
          aspectRatio: 5.1,
          height: 36,
          backgroundColor: "transparent",
          src: `${CDN}/images/logos/otto.svg`,
          altText: "AutoGuru logo"
        })
      })
    }), _Column2 || (_Column2 = /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx(AppSideHandle, {})
    }))]
  })
});